import createIcon from '../../createIcon';

/**
 * @component @name DragHandle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgOUg0VjExSDIwVjlaTTQgMTVIMjBWMTNINFYxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DragHandle = createIcon('DragHandle', [
  ['path', { d: 'M20 9H4V11H20V9ZM4 15H20V13H4V15Z', key: '1lsxza' }],
]);

export default DragHandle;
